import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M784.53,731.95v52.41H15.86c-3.2-82.2,13.12-163.03,55.86-233.49,45.81-75.54,115.27-130.98,197.41-162.86-108.77-86.05-102.73-259.03,13.35-336.1,157.02-104.25,358.38,31.15,322.35,215.35-9.11,46.59-36.97,91.05-73.56,120.75,36.42,15.51,70.73,33,102.37,57,89.47,67.88,144.3,175.09,150.9,286.93ZM380.05,86.18c-51.02,5.74-99.87,48.81-114.18,97.65-39.08,133.42,116.57,237.86,222.69,150.63,109.64-90.12,34.63-264.39-108.52-248.28ZM712.47,714.48c-19.07-194.02-212.2-321.68-400.09-267.98-119.34,34.11-213.63,143.37-224.45,267.98h624.54Z"
	})
});
export default SvgUser;
